<template>
  <div id="Youtube" v-if="this.userData.data.username == 'admin'">
    <!-- <Breadcrumb :list="list"/> -->
    <div v-show="loader">
      <Loader />
    </div>
    <div class="datepickerwrap card mx-3">
      <div class="leftcontent wrapitem w-100">

        <div class="datebox" style="min-width:17%">
          <select @change="refresh" v-model="selected_website" class="customSelect form-control text-uppercase">
            <option value="all">All</option>
            <option value="https://store.acer.com/en-us">Acer</option>
            <option value="https://www.amazon.com">Amazon</option>
            <option value="https://www.amazon.fr">Amazon France</option>
            <option value="https://www.amazon.co.it">Amazon Italy</option>
            <option value="https://www.amazon.es">Amazon Spain</option>
            <option value="https://www.amazon.co.uk">Amazon UK</option>
            <option value="https://www.amazon.de">Amazon Germany</option>
            <option value="https://store.asus.com/us">ASUS</option>
            <option value="https://www.bestbuy.com">Best Buy</option>
            <option value="https://www.newegg.com">Newegg</option>
            <option value="https://www.microcenter.com">Microcenter</option>
            <option value="https://store.hp.com/us#commercial">Commercial HP US</option>
            <option value="https://store.hp.com/GermanyStore#commercial">Commercial HP Germany</option>
            <option value="https://www.lenovo.com/us#commercial">Commercial Lenovo US</option>
            <option value="https://www.costco.com">Costco</option>
            <option value="https://www.dell.com/en-us">Dell</option>
            <option value="https://www.currys.co.uk">Curry's</option>
            <option value="https://www.harveynorman.com.au">Harvey Norman</option>
            <option value="https://www8.hp.com/jp">HP Japan</option>
            <option value="https://store.hp.com/UKStore">HP UK</option>
            <option value="https://store.hp.com/us">HP US</option>
            <option value="https://global.jd.com">JD</option>
            <option value="https://www.lenovo.com/de">Lenovo Germany</option>
            <option value="https://www.lenovo.com/gb">Lenovo UK</option>
            <option value="https://www.lenovo.com/us">Lenovo US</option>
            <option value="https://www.mediamarkt.de">MediaMarkt</option>
            <option value="https://www.walmart.com">Walmart</option>
          </select>
        </div>
        <div class="datebox">
          <select v-model="device" @change="refresh" class="customSelect form-control text-uppercase">
            <option value="laptop">Laptop PC</option>
            <option value="desktop">Desktop</option>
          </select>
        </div>
        <div v-show="false" class="datebox">
          <div style="padding: 5px; height: 30px; border: none; background: rgb(138, 135, 232); color: white;">
            <input @change="refresh" v-model="isAllDates" style="float: left;margin-right: 6px; margin-top: 3px;"
              type="checkbox">
            <span>All Dates</span>
          </div>
        </div>
        <div v-show="false" v-if="!isAllDates" class="datebox">
          <div style="display:flex">
            <div style="margin-left: 6px;padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">From
            </div>
            <datepicker placeholder="From" @input="refresh" v-model="date.startDate" />
          </div>
        </div>
        <div v-show="false" v-if="!isAllDates" class="datebox">
          <div style="display:flex">
            <div style="margin-left: 6px;padding: 5px;height: 30px;border: none;background: #8a87e8;color: white;">To
            </div>
            <datepicker v-model="date.endDate" class="picker-left" placeholder="To" @input="refresh" />
          </div>
        </div>
        <div class="datebox action-btn-grp">
          <button @click="saveNow" class='primarycolor'>Save</button>
          <button style="margin-left: 10px;" @click="refresh" class="primarycolor">Refresh</button>
        </div>
      </div>
    </div>

    <div class="card mx-3 scrolled-table">
      <table class="rounded-corners w-100">
        <thead>
          <tr>
            <th class="py-3" style="min-width:120px; font-size: 14px;" v-for="d in tableData.row" :key='d.key'>{{ d.label
            }}</th>
          </tr>
        </thead>
        <tbody>
          <tr :class="{ redbg: !d.updated }" v-for="d in tableData.data" :key='d.product_name'>
            <td :class="{ ybg: saveTrack.includes(d.link) && col.key == 'product_name' }" v-for="col in tableData.row"
              :key='col.key'>
              <span v-if="!col.isDropdown">
                <span v-if="col.key != 'product_name'">
                  <span v-if="col.key != 'last_updated'">
                    {{ d[col.key] }}
                  </span>
                  <span v-if="col.key == 'last_updated'">
                    <span v-if="d[col.key] != null">
                      {{ moment(d[col.key]).format('DD MMM YYYY') }}
                    </span>
                    <span v-if="d[col.key] == null">
                      N/A
                    </span>
                  </span>
                </span>
                <span v-if="col.key == 'product_name'" class="px-2"> <a target="_blank" :href="d.link"> {{ d.product_name }}
                  </a></span>
              </span>
              <span v-if="col.isDropdown">
                <select @change="addToChanged(d)" class="form-control customSelect" v-model="d[col.key]">
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import Loader from '../Components/Loader.vue';

export default {
  name: 'AdminDashboard',
  components: {
    Datepicker,
    Loader
  },

  data: function () {
    return {
      data: [],
      isAllDates: false,
      moment: moment,
      userData: JSON.parse(localStorage.getItem('reviewUserData')),
      customData: JSON.parse(localStorage.getItem('reviewCustomData')),
      loader: false,
      selected_website: 'https://store.hp.com/us',
      date: {
        startDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        endDate: moment().subtract(1, 'days').format('YYYY-MM-DD')
      },
      device: 'laptop',
      tableData: {
        row: [
          { key: 'product_name', label: 'Product Name', isDropdown: false },
          { key: 'processor_type', label: 'Processor Type', isDropdown: false },
          { key: 'last_updated', label: 'Last Updated', isDropdown: false },
          { key: 'cpu_logo', label: 'CPU Logo', isDropdown: true },
          { key: 'gpu_logo', label: 'GPU Logo', isDropdown: true },
          { key: 'nomenclature', label: 'Nomenclature', isDropdown: true },
        ],
        data: []
      },
      saveTrack: [],
      saveData: []
    }
  },
  mounted() {
    this.refresh()

  },
  methods: {
    addToChanged(d) {
      if (!this.saveTrack.includes(d.link)) {
        this.saveTrack.push(d.link)
        this.saveData.push(d)
      }
    },
    saveNow() {
      let self = this
      if (!self.saveData.length) {
        alert('No Change')
        return
      }
      this.loader = true
      let payload = {
        "admin_table": self.saveData,
        "website": self.selected_website,
        "item_category": self.device
      }
      const url = "/api/websites/save_compliance_new"
      self.$http.post(url, payload).then(response => {
        alert('Saved')
        self.refresh()
        self.loader = false
      }, err => {
        self.loader = false
        self.refresh()
        alert('Error in Saving')
      });
    },

    refresh() {
      this.saveData = []
      this.saveTrack = []
      this.tableData.data = []
      this.getData()
    },

    getData() {
      let self = this
      this.loader = true
      let payload = {
        "website": this.selected_website,
        "item_category": self.device
      }
      if (!self.isAllDates) {
        payload.start_date = moment(self.date.startDate).format('YYYY-MM-DD')
        payload.end_date = moment(self.date.endDate).format('YYYY-MM-DD')
      }
      const url = "/api/websites/compliance_raw_new"
      self.$http.post(url, payload).then(response => {
        self.tableData.data = response.body.data
        self.loader = false
      }, err => {
        self.loader = false
      });
    },
  }
}

</script>

<style scoped>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.card_vivo {
  background-color: #0072ba !important;
  border: 1px solid #0072ba !important;
}

.card_realme {
  background-color: #f3b821 !important;
  border: 1px solid #f3b821 !important;
}

.card_redmi {
  background-color: #f56628 !important;
  border: 1px solid #f56628 !important;
}

.badge {
  padding: 5px;
  font-size: 13px;
}

.redbg {
  background: var(--red-20);
  color: inherit
}

.ybg {
  background: #ffff9c;
  color: inherit
}

.greenbg {
  color: green;
  cursor: pointer;
}

.highcharts-figure .chart-container {
  width: 300px;
  height: 200px;
  float: left;
}

.thead-normal th,
.tbody-normal td {
  border: 1px solid silver !important;
}

.thead-normal tr {
  background: rgb(138, 135, 232);
  color: white
}

.saveBtn {
  background-color: #b4ffb3;
  border-radius: 0;
  height: 30px;
  border: none;
  width: 60px
}

/* New dashboard styles */
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

select option {
  text-transform: capitalize !important;
  padding: 10px 0px !important;
}

select {
  font-family: "Poppins", sans-serif !important;
}

customSelect {
  background: var(--base_color-5) !important;
  color: var(--primary_brand-60) !important;
  border: 1px solid var(--primary_brand-60) !important;
}

.customSelect:focus {
  background: var(--base_color-5) !important;
  color: var(--primary_brand-60) !important;
  border: 1px solid var(--primary_brand-60) !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: 600 !important;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
  border: none !important;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.action-btn-grp {
  width: 30%;
}

@media (max-width: 790px) {
  .scrolled-table {
    max-width: 100vw;
    overflow-x: auto;
  }
  .action-btn-grp {
    width: 50%;
  }
}

@media (max-width: 490px) {
  .action-btn-grp {
    width: 100%;
  }
}
</style>
